import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useLoginStore } from "@/store/auth";
import { createRouter, createWebHistory, useRouter } from "vue-router";
import rutasClientes from "./routes/dashboard/clientes";
import arrendamientosTipo from "./routes/dashboard/arrendamientos-tipo";
import arrendamientoEnganches from "./routes/dashboard/arrendamiento-enganches";
import arrendamientoResiduales from "./routes/dashboard/arrendamiento-residuales";
import rutasUsuarios from "./routes/dashboard/usuarios";
import rutasCotizacion from "./routes/dashboard/cotizaciones";
import rutasContratos from "./routes/dashboard/contratos";
import rutasTablaTIR from "./routes/dashboard/tabla-tir";
import cotizacionPublica from "./routes/public/cotizacion-publica";
import calculadoraPublica from "./routes/public/calculadora";
import rutasFatoraje from "./routes/dashboard/factoraje";

const routes = [
  {
    path: "/auth",
    name: "auth",
    component: () =>
      import(
        /* webpackChunkName: 'Auth-Layout' */ "@/modules/auth/layouts/AuthLayout"
      ),
    children: [
      {
        path: "login",
        name: "login",
        component: () =>
          import(
            /* webpackChunkName: 'Auth-Login' */ "@/modules/auth/pages/login"
          ),
      },
    ],
  },
  {
    path: "/console",
    name: "console",
    redirect: {
      name: "cotizacion-rapida",
    },
    component: () =>
      import(
        /* webpackChunkName: "Dashboard-Layout" */ "@/modules/dashboard/layouts/DashboardLayout"
      ),
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () =>
          import(
            /* webpackChinkName: 'Dashboard-Charts' */ "@/modules/dashboard/pages/dashboard/"
          ),
      },
      {
        path: "",
        name: "dashboard-index",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard" */ "@/modules/dashboard/pages/dashboard"
          ),
      },
      {
        path: "reportes",
        name: "reportes",
        component: () =>
          import(
            /* webpackChunkName: 'Dashboard-Reportes' */ "@/modules/dashboard/pages/reportes/"
          ),
      },
      rutasClientes,
      arrendamientosTipo,
      arrendamientoEnganches,
      arrendamientoResiduales,
      rutasUsuarios,
      rutasCotizacion,
      rutasContratos,
      rutasTablaTIR,
      {
        path: "factoraje",
        name: "factoraje",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard-Factoraje-Layout" */ "@/modules/dashboard/pages/factoraje"
          ),
      },
      {
        path: "factoraje/cotizacion/nueva",
        name: "factoraje-cotizacion-nueva",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard-Factoraje-NuevaCotizacion" */ "@/modules/dashboard/pages/factoraje/cotizacion/nueva"
          ),
      },
      {
        path: "factoraje/cotizacion/:cotizacion_id/detalle",
        name: "factoraje-cotizacion-detalle",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard-Factoraje-DetalleCotizacion" */ "@/modules/dashboard/pages/factoraje/cotizacion/detalle"
          ),
      },
      {
        path: "factoraje/cotizacion/historial",
        name: "factoraje-cotizacion-historial",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard-Factoraje-HistorialCotizacion" */ "@/modules/dashboard/pages/factoraje/cotizacion/historial"
          ),
      },
      {
        path: "/:pathMatch(.*)*",
        component: () =>
          import(
            /* webpackChunkName: "Not-Found-404" */ "@/components/NotFoundPage"
          ),
      },
    ],
  },

  {
    path: "/",
    name: "/",
    redirect: {
      name: "login",
    },
  },
  cotizacionPublica,
  calculadoraPublica,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  //history: createWebHashHistory(),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, next) => {
  const { matched } = to;
  const { userStoreModules } = storeToRefs(useLoginStore());

  if (matched[0].path == "/console" && userStoreModules.length > 0) {
    const userModules = ref(JSON.parse(userStoreModules.value));
    const modules = userModules.value.map((val) => val.url_nombre);
    const router = useRouter();

    if (!modules.includes(matched[0].name)) {
      router.push({
        name: "cotizacion-rapida",
      });
    }
  }
  /* const { matched } = to;
  if (matched[0] ==) {
  } */
  //next();
  /* if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !_id &&
    !_token &&
    !_nombre
  ) {
    next({
      name: "login",
    });
  } else {
    next();
  } */
});

export default router;
